import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import skillHierarchyResource from 'src/actions/skills/skillHierarchyResource';
import skillsResource from 'src/actions/skills/skillsResource';
import fetchSkillsAndHierarchies from 'src/actions/skills/fetchSkillsAndHierarchies';
import { useResourceValues } from 'src/presentation/hooks/useResource';

export default function useSkills() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchSkillsAndHierarchies());

    return () => {
      dispatch(skillsResource.effects.unload());
      dispatch(skillHierarchyResource.effects.unload());
    };
  }, [dispatch]);
  return useResourceValues(skillsResource);
}
